module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/7ztozF2GmLHXwegaMrQhYJ-b2ce87a10016fc8cf53e3c32a975bc96.jpg";